import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
// TODO: update
import 'swiper/swiper.min.css';
import 'swiper/css';
import 'swiper/css/lazy';
import 'swiper/css/pagination';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Autoplay, Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import SliderContext from 'provider/Slider';

import ImageKit from '../Image';

const useStyle = makeStyles((theme) => ({
	wrapper: {
		position: 'relative',
		height: 600,
		width: '100%',
		display: 'flex',
		'& .swiper-wrapper': {
			boxSizing: 'border-box',
			[theme.breakpoints.only('lg')]: {
				width: '55rem',
			},
		},
		'& .swiper-slide': {
			[theme.breakpoints.between('md', 'lg')]: {
				height: '40rem !important',
				position: 'relative',
			},
		},
		'& .swiper-container': {},
		[theme.breakpoints.between('xs', 'sm')]: {
			height: '30rem !important',
			position: 'relative',
		},

		[theme.breakpoints.between('sm', 'md')]: {
			height: '30rem !important',
			position: 'relative',
		},

		[theme.breakpoints.between('md', 'lg')]: {
			height: '60rem !important',
			position: 'relative',
		},
	},
	direction: {},
	dots: {
		display: 'flex',
		transform: 'rotate(0)',
		height: 'auto',
	},
	dotsVertical: {
		display: 'flex',
		flexDirection: 'column',
		height: '8rem',
		position: 'relative',
		top: '65%',
		[theme.breakpoints.between('md', 'lg')]: {
			top: '35%',
		},
		[theme.breakpoints.only('lg')]: {
			top: '55%',
		},
	},
	dot: {
		border: 'none',
		height: '0.5rem',
		width: '0.4rem',
		background: theme.palette.background.light,
		borderRadius: '50%',
		margin: '0 0.5rem',
		padding: '0.4rem 0.5rem',
		cursor: 'pointer',

		'&:focus': {
			outline: 'none',
		},
	},
	dotVertical: {
		border: 'none',
		height: '.4rem',
		width: '0.5rem',
		background: theme.palette.background.light,
		borderRadius: '36px',
		margin: '0.5rem 0',
		padding: '0.5rem 0.3rem',
		cursor: 'pointer',
		'&:focus': {
			outline: 'none',
		},
	},
	active: {
		background: theme.palette.secondary[700],
		width: '2rem',
		borderRadius: '3.2rem',
		boxShadow: `-0.3rem 0.1rem 0.9rem ${theme.palette.secondary[700]}`,
	},
	activeVertical: {
		background: theme.palette.secondary[700],
		height: '2rem',
		borderRadius: '3.2rem',
		boxShadow: `0.1rem 0.1rem 0.9rem ${theme.palette.secondary[700]}`,
	},
}));

const SwiperKit = (props) => {
	const classes = useStyle();
	const { children, rootClassName, innerProps } = props;
	const { state, setState } = useContext(SliderContext);

	return (
		<Box
			className={clsx(rootClassName ? rootClassName : classes.wrapper, {
				[classes.direction]: !innerProps?.direction?.includes('vertical'),
			})}
		>
			<Swiper
				className="swiper"
				modules={[Lazy, Autoplay]}
				onSwiper={(_swiper) => {
					setState((prev) => ({
						...prev,
						_swiper,
					}));
				}}
				freeMode={true}
				onSlideChange={({ activeIndex, realIndex, slides }) => {
					setState((s) => ({
						...s,
						activeIndex,
						miniStep: realIndex + 1,
						slides: slides?.length - 2,
					}));
				}}
				{...innerProps}
			>
				{!props.proMode &&
					props.data.map((item, key) => (
						<SwiperSlide key={`image-of-item-${key}`}>
							{props.mode === 'image' && (
								<>
									<ImageKit src={item.img} quality={65} {...props.imageProperty} priority={true} />
									{innerProps.lazy && <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />}
								</>
							)}
							{props.mode === 'element' && React.cloneElement(children, item)}
						</SwiperSlide>
					))}

				{props.proMode &&
					React.Children.map(children, (child, i) => (
						<SwiperSlide
							key={`featuredCape-${i}`}
							className={child?.props.className ? `swiper-slide ${child.props.className}` : 'swiper-slide'}
						>
							{child}
							{innerProps.lazy && <div className="swiper-lazy-preloader swiper-lazy-preloader-white" />}
						</SwiperSlide>
					))}
			</Swiper>

			{props.bullet && (
				<Box className={props.bullet ? props.bullet : ''}>
					<div
						className={clsx({
							[classes.dots]: !innerProps?.direction?.includes('vertical'),
							[classes.dotsVertical]: innerProps?.direction?.includes('vertical'),
						})}
					>
						{React.Children.toArray(
							Array(3)
								.fill('')
								.map((_, idx) => (
									<Box
										component={'span'}
										onClick={() => {
											setState((prev) => ({
												...prev,
												activeIndex: idx + 1,
											}));
											state._swiper.slideToLoop(idx);
										}}
										className={clsx({
											[classes.active]:
												state?._swiper?.realIndex === idx + 1 && !innerProps?.direction?.includes('vertical'),
											[classes.activeVertical]: state?._swiper?.realIndex === idx,
											[classes.dot]: !innerProps?.direction?.includes('vertical'),
											[classes.dotVertical]: innerProps?.direction?.includes('vertical'),
										})}
									/>
								)),
						)}
					</div>
				</Box>
			)}
		</Box>
	);
};

SwiperKit.defaultProps = {
	data: [],
	swiperRef: null,
	innerProps: {
		direction: 'vertical',
		lazy: true,
		modules: [],
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		slidesPerView: 1,
	},
	mode: 'image',
	proMode: false,
	bullet: false,
};

SwiperKit.prototype = {
	data: PropTypes.array.isRequired,
	mode: PropTypes.oneOf(['image', 'element']),
	proMode: PropTypes.bool.isRequired,
};

export default SwiperKit;
